import React, { useEffect, useState } from 'react';
import { Alert, Stack } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { EmptySectionMessage, FullPageLoader } from '@tassomutuo-backoffice/ui';
import { Lead } from '@tassomutuo-backoffice/types';
import { getDropRequests } from '../../../../services/api/lead/lead';
import LeadCardList from './LeadCardList';

/**
 * The Mutui Drop queue: same endpoint and actions as before, presented with the
 * same card language as Prestiti and CdQ. Those products are served by another
 * backend and workflow, so they remain a separate panel rather than an
 * extension of this one.
 */
const MortgageDropRequestsPanel = () => {
  const { isPending, data, error } = useQuery({
    queryKey: ['getDropRequests'],
    queryFn: getDropRequests,
  });

  const [leadsToShow, setLeadsToShow] = useState<Lead[]>([]);

  useEffect(() => {
    if (data && data.length > 0) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setLeadsToShow(data);
    }
  }, [data]);

  const dropRequest = data || [];

  return (
    <>
      <FullPageLoader show={isPending} />
      <Stack spacing={2}>
        {!isPending && error && (
          <Alert severity="error">
            {error.message ? `Error: ${error.message}` : 'An Error occurred'}
          </Alert>
        )}
        {dropRequest && dropRequest?.length > 0 && (
          <>
            {leadsToShow.map((lead) => {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              return <LeadCardList key={lead.id} lead={lead} />;
            })}
          </>
        )}
        {dropRequest && dropRequest?.length === 0 && (
          <EmptySectionMessage title="Non ci sono lead da mostrare" />
        )}
        {dropRequest &&
          dropRequest?.length > 0 &&
          leadsToShow &&
          leadsToShow.length === 0 && (
            <EmptySectionMessage title="La ricerca non ha prodotto risultati" />
          )}
      </Stack>
    </>
  );
};

export default MortgageDropRequestsPanel;
